import { render } from "./Styles.vue?vue&type=template&id=a51559e2&scoped=true&ts=true"
import script from "./Styles.vue?vue&type=script&lang=ts"
export * from "./Styles.vue?vue&type=script&lang=ts"

import "./Styles.vue?vue&type=style&index=0&id=a51559e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a51559e2"]])

export default __exports__